export default __webpack_public_path__ + "img/1f640.190501c32d290c00d8ab7c069e5eab5a.png";